import { UserDisplay } from '@/components'
import { PointerBubbleShell } from '@/components/PointerBubble/PointerBubbleShell'
import { ResponseThread } from '@/schema'
import { cn } from '@/utils/common'

import { useGetUserCommentData } from '../Thread/hooks/useGetUserCommentData.ts'

interface CommentAvatarProps {
  comment: ResponseThread
  position: { top: number; left: number }
  isActive: boolean
  onClick: (commentId: string) => void
}

export const CommentAvatar = ({
  comment,
  position,
  isActive,
  onClick,
}: CommentAvatarProps) => {
  const { authorName } = useGetUserCommentData(comment, '')
  const hasUnReadReplies = comment.has_unread_replies

  return (
    <button
      className={cn(
        'absolute z-40 cursor-pointer transition-all duration-200 bg-transparent border-0 p-0',
        'hover:scale-110',
        isActive && 'z-50 scale-110'
      )}
      data-comment-avatar={comment.id}
      style={{
        top: `${position.top}px`,
        left: `${position.left}px`,
        pointerEvents: 'auto',
      }}
      onClick={(e) => {
        e.stopPropagation()
        onClick(comment.id)
      }}
      tabIndex={0}
      aria-label={`Comment by ${authorName}`}
    >
      <PointerBubbleShell
        className={cn(hasUnReadReplies ? 'text-blue-600' : 'text-gray-500')}
        size={44}
      >
        <UserDisplay
          user={comment.created_by_user}
          showName={false}
          avatarSize="size-7 h-7 w-7"
        />
      </PointerBubbleShell>
    </button>
  )
}
